import Loading from './Loading/index'
// import NoData from './NoData/index'
// import Modal from './Modal/index'
// import Popover from './Popover/index'

const install = Vue => {
  Vue.component('Loading', Loading)
  // Vue.component('NoData', NoData)
  // Vue.component('Modal', Modal)
  // Vue.component('Popover', Popover)
}

export default install




// WEBPACK FOOTER //
// ./src/components/index.js